module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-e577fbcfca44dbd7a883fd155383b473.png";